function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1C1C1C;stroke:#12dcff;stroke-width:11;}\n\t.st2{fill:#1C1C1C;}\n\t.st3{fill:none;stroke:#12dcff;stroke-width:11;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 114.88,
  cy: 114.88,
  r: 112.41
})), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M168.06,106.14l-11.15-3.05c-1.64-3.87-2.35-5.52-3.87-9.51l5.75-10.1c0.82-1.41,0.59-3.17-0.59-4.23 l-7.51-7.51c-1.17-1.17-2.93-1.41-4.23-0.59l-10.1,5.75c-3.87-1.64-5.52-2.35-9.51-3.87l-3.05-11.15c-0.47-1.53-1.88-2.58-3.4-2.58 h-10.68c-1.64,0-3.05,1.06-3.4,2.58l-3.05,11.15c-3.87,1.64-5.52,2.35-9.51,3.87l-10.1-5.75c-1.41-0.82-3.17-0.59-4.23,0.59 l-7.51,7.51c-1.17,1.17-1.41,2.93-0.59,4.23l5.75,10.1c-1.64,3.87-2.35,5.52-3.87,9.51l-11.15,3.05c-1.53,0.47-2.58,1.88-2.58,3.4 v10.68c0,1.64,1.06,3.05,2.58,3.4l11.15,3.05c1.64,3.87,2.35,5.52,3.87,9.51l-5.75,10.1c-0.82,1.41-0.59,3.17,0.59,4.23l7.51,7.51 c1.17,1.17,2.93,1.41,4.23,0.59l10.1-5.75c3.87,1.64,5.52,2.35,9.51,3.87l3.05,11.15c0.47,1.53,1.88,2.58,3.4,2.58h10.68 c1.64,0,3.05-1.06,3.4-2.58l3.05-11.15c3.87-1.64,5.52-2.35,9.51-3.87l10.1,5.75c1.41,0.82,3.17,0.59,4.23-0.59l7.51-7.51 c1.17-1.17,1.41-2.93,0.59-4.23l-5.75-10.1c1.64-3.87,2.35-5.52,3.87-9.51l11.15-3.05c1.53-0.47,2.58-1.88,2.58-3.4v-10.68 C170.65,108.02,169.59,106.61,168.06,106.14z M114.88,139.6c-13.62,0-24.65-11.04-24.65-24.65s11.04-24.65,24.65-24.65 s24.65,11.04,24.65,24.65S128.5,139.6,114.88,139.6z"
}));

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 229.77 229.77",
    style: {
      enableBackground: "new 0 0 229.77 229.77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7893141a.svg";
export { ForwardRef as ReactComponent };